export default "<!-- <fuse-progress-bar></fuse-progress-bar> -->\n<loading></loading>\n\n<vertical-layout-1></vertical-layout-1>"